module.exports = __webpack_public_path__ + "static/media/SevereThunderstrom.ac9aa0d0.svg";